import React from 'react';
import { cn } from '../../../../../../../../../utils/styles';

interface IModuleEditBlock {
  title: string;
  subTitle: string | React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

function ModuleEditBlock({ subTitle, title, className, children }: IModuleEditBlock) {
  return (
    <div className={cn('px-[10px]', className)}>
      <div className="mb-[15px]">
        <div className="text-primary font-bold">{title}</div>
        <div className="text-sm text-addition1-50 font-medium">{subTitle}</div>
      </div>
      {children}
    </div>
  );
}

ModuleEditBlock.defaultProps = {
  className: '',
};

export default ModuleEditBlock;
